module.exports = __webpack_public_path__ + "static/img/funny_09.7a90d54f.jpg";